module.exports = __webpack_public_path__ + "img/report.c5c11dfd.png";